import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../ui/LoadingSpinner';
import StripeCheckout from '../business/StripeCheckout';

const ProtectedRoute = ({ children, requiresSubscription = true }) => {
  const { isAuthenticated, needsSubscription, loading, isStudent } = useAuth();

  // Show loading state while checking authentication
  if (loading) {
    return <LoadingSpinner />;
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If authenticated but needs subscription and route requires it
  if (requiresSubscription && needsSubscription && !isStudent) {
    return <Navigate to="/checkout" replace />;
  }

  if (isStudent)
  {
    return <Navigate to="/student" replace/>
  }

  // If authenticated and either doesn't need subscription or route doesn't require it
  return children;
};

export default ProtectedRoute;